import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDateFilterName } from './date-filter-helper';
import { getAggregationItemTitle } from '../../../../play-core/models/search/MediaSearchResponse';
const defaultOptions = {
  showMediaType: true,
  removeAllPosition: 'start'
};
export const useFilterChips = (query, mediaResult, dispatch, options = defaultOptions) => {
  const {
    t
  } = useTranslation();
  const getChipTitle = useCallback((aggregationId, type) => getAggregationItemTitle(aggregationId, type, mediaResult), [mediaResult]);
  return useMemo(() => createChips(query, options, getChipTitle, dispatch, t), [query, options, getChipTitle, dispatch, t]);
};
export const createChips = (query, options, getTitle, dispatch, t) => {
  let newChips = [];
  if (options.showMediaType && query.mediaType) {
    newChips.push({
      id: 'mediaType',
      title: t(`search.mediaType.${query.mediaType}`),
      onClick: () => dispatch({
        type: 'remove-media-type-filter'
      })
    });
  }
  newChips = [...newChips, ...(query.shows?.map(showId => ({
    id: showId,
    title: getTitle(showId, 'shows'),
    onClick: () => dispatch({
      type: 'remove-show-filter',
      show: showId
    })
  })) ?? [])];
  newChips = [...newChips, ...(query.topics?.map(topicId => ({
    id: topicId,
    title: getTitle(topicId, 'topics'),
    onClick: () => dispatch({
      type: 'remove-topic-filter',
      topic: topicId
    })
  })) ?? [])];
  const mediaPropertyChips = query.mediaProperties?.map(propertyName => ({
    id: propertyName,
    title: t(`search.property.${propertyName}`),
    onClick: () => dispatch({
      type: 'remove-property-filter',
      property: propertyName
    })
  })) ?? [];
  newChips = [...newChips, ...mediaPropertyChips];
  if (query.duration) {
    newChips.push({
      id: 'duration',
      title: t(`search.${query.duration}`),
      onClick: () => dispatch({
        type: 'remove-duration-filter'
      })
    });
  }
  if (query.from && query.to) {
    newChips.push({
      id: 'dateFilter',
      title: t(getDateFilterName(query.from, query.to)),
      onClick: () => dispatch({
        type: 'remove-date-filter'
      })
    });
  }
  if (newChips.length > 3) {
    const removeAll = {
      id: 'removeAll',
      title: t('search.deleteAllFilter'),
      showBorder: false,
      onClick: () => options.removeAllOnClick ? options.removeAllOnClick() : dispatch({
        type: 'remove-all-filters'
      })
    };
    if (options.removeAllPosition === 'end') {
      newChips.push(removeAll);
    } else {
      newChips.unshift(removeAll);
    }
  }
  return newChips;
};